import createBusinessAddressGQL from "../../../../graphQl/mutations/createBusinessAddress";

export const createBusinessAddress = async ({ dispatch, commit, rootGetters }, payload) => {
  const organizationId = rootGetters['app/getSelectedOrganization'].id;

  let response;

  try {
    response = await dispatch('app/request', {
      type: 'mutation',
      gql: createBusinessAddressGQL,
      variables: {
        organizationId,
        ...payload,
      },
    }, {root: true});
  } catch (error) {
    return error;
  }

  return ( response.data && response.data.createBusinessAddress ) ? response.data.createBusinessAddress : {}
};